import { NgModule } from '@angular/core';
import { FocusNearestDirective } from './focusNearest.directive';

@NgModule({
  declarations: [FocusNearestDirective],
  exports: [FocusNearestDirective],
})
export class FocusNearestModule {}
